const PERMISSIONS_KEY = 'user_data'

const setUserData = (userData) => {
    sessionStorage.setItem(PERMISSIONS_KEY, JSON.stringify(userData))
}

const getUserData = () => JSON.parse(sessionStorage.getItem(PERMISSIONS_KEY))

const removeUserData = () => sessionStorage.removeItem(PERMISSIONS_KEY)

export { setUserData, getUserData, removeUserData }
